module.exports = __webpack_public_path__ + "static/media/new-banner.0339f22c.png";